import React from 'react';
import ReactTooltip from 'react-tooltip';
import Registry from 'registry';

import {t} from 'l10n';

export default function RoomItemInfoTooltip({room}) {
    let id = 'tooltip-'+room.roomid;

    return (Registry.get('ENVIRONMENT', false) !== 'server') ? (
        <i className="icon-info" data-tip='' data-for={id}>
            <ReactTooltip id={id} type="light" place="bottom" className="tooltip tooltip-room">
                <p className="name">bobTV {room.name}</p>
                <p>{room.description}</p>
                {room.userLimit && <p dangerouslySetInnerHTML={{__html: t('Room limit: <strong>%1</strong> users', room.userLimit)}}></p>}
                {/*<p className="link"><a href="#">Instructions for use of rooms <span></span></a></p>*/}
            </ReactTooltip>
        </i>
    ) : null;
}


// WEBPACK FOOTER //
// ./src/components/index/RoomItemInfoTooltip.js